import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  tagsWrapper: FelaCSS;
  title: FelaCSS;
  subtitle: FelaCSS;
}

const styles: IStyles = {
  wrapper: {
    height: '100%',
    minWidthDesktop: {
      cursor: 'pointer',
    },
  },

  tagsWrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    marginBottom: 1,
    gap: '8px',
  },

  title: {
    fontDefaultSemiBold: 14,
    color: colors.space,
    paddingTop: 2,
  },

  subtitle: {
    fontDefault: 14,
    color: colors.space,
    wordBreak: 'break-word',
  },
};

export default styles;
